export const LICENSE_TYPES = {
  BROADCAST: 'Broadcast',
  CLOUD_ENT: 'Cloud-Ent',
  LAN_CLOUD: 'Lan+Cloud',
  CLOUD_PRO: 'Cloud-Pro',
  USER: 'User',
} as const;
